import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Projects from '../components/Projects';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Hobbies from '../components/Hobbies';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import '../styles/portfolio.css';

const Portfolio = () => {
  return (
    <div className="portfolio">
      <Header />
      <main>
        <Hero />
        <About />
        <Projects />
        <Skills />
        <Experience />
        <Hobbies />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Portfolio;